
interface RecommendItem {
  thumbnails?: {
    image?: { url?: string }[]
  }
}

/**
 * 从推荐位碎片里的某篇文章获取缩略图
 *
 * @param data 推荐位碎片单篇文章
 * @return 该文章的缩略图
 * */
export const getThumbnailFromRecommend = (data: RecommendItem):string => {
  const image = data.thumbnails.image && data.thumbnails.image[0] && data.thumbnails.image[0].url;

  return image || '';
};
